import React from 'react';
import { ArrowRight, RefreshCw } from 'lucide-react';
import { formatoMonto } from '../compartidos/useAnalisis';

const corto = (v) => (v ? `…${String(v).slice(-8)}` : '—');

// G3: visualización especial de flujo circular (se mantiene), armada con los movimientos del episodio.
export const FlujoCircular = ({ filas }) => {
  const flujos = filas.map((m) => (m.sentido === 'INGRESO'
    ? { origen: m.contraparte_cvu, destino: m.cvu_propio, monto: m.monto, ingreso: true }
    : { origen: m.cvu_propio, destino: m.contraparte_cvu, monto: m.monto, ingreso: false }));
  const cuentas = new Set(flujos.flatMap((f) => [f.origen, f.destino]).filter(Boolean));
  const total = flujos.reduce((s, f) => s + (f.monto || 0), 0);
  return (
    <div className="mb-4 rounded-xl border border-purple-200 bg-purple-50/60 p-4" data-testid="flujo-circular">
      <h4 className="mb-3 flex items-center gap-2 text-sm font-semibold text-purple-800">
        <RefreshCw size={16} /> Análisis de flujo circular detectado
      </h4>
      <div className="grid gap-4 md:grid-cols-2">
        <div className="space-y-1.5 text-sm text-purple-800">
          <p>El dinero circula entre cuentas relacionadas.</p>
          <p><span className="font-medium">Cuentas involucradas:</span> {cuentas.size}</p>
          <p><span className="font-medium">Transferencias (esta página):</span> {flujos.length}</p>
          <p><span className="font-medium">Monto:</span> <span className="font-mono">{formatoMonto(total)}</span></p>
        </div>
        <div className="max-h-36 space-y-1.5 overflow-y-auto rounded-lg border border-purple-200 bg-white p-3">
          {flujos.slice(0, 10).map((f, i) => (
            <div key={i} className="flex items-center gap-2 text-xs">
              <span className={`rounded px-2 py-0.5 font-mono ${f.ingreso ? 'bg-emerald-100 text-emerald-700' : 'bg-sky-100 text-sky-700'}`}>{corto(f.origen)}</span>
              <ArrowRight size={13} className="text-purple-500" />
              <span className={`rounded px-2 py-0.5 font-mono ${f.ingreso ? 'bg-sky-100 text-sky-700' : 'bg-emerald-100 text-emerald-700'}`}>{corto(f.destino)}</span>
              <span className="ml-auto font-mono text-slate-500">{formatoMonto(f.monto)}</span>
            </div>
          ))}
          {flujos.length > 10 && <p className="text-xs italic text-purple-500">+ {flujos.length - 10} transferencias más…</p>}
        </div>
      </div>
    </div>
  );
};

export default FlujoCircular;
